import { useQuery } from '@tanstack/react-query';
import { personalSummaryService } from '../api/personal-summary.service';
import { PERSONAL_SUMMARY_KEYS } from './queryKeys';
import type { MyOverdueTasksParams } from '../types';

export function useMyOverdueTasks(params?: MyOverdueTasksParams) {
  return useQuery({
    queryKey: PERSONAL_SUMMARY_KEYS.overdueTasks(params),
    queryFn: ({ signal }) => personalSummaryService.getMyOverdueTasks(params, signal),
    staleTime: 120_000,
  });
}
